import { jsx as _jsx } from "react/jsx-runtime";
import { TreeItem2 } from '@mui/x-tree-view';
import { useNavigate } from 'react-router-dom';
import { ContainerArbitrator } from '../../../ArbitrationObjects/ContainerArbitrator/containerArbitrator';
import { AlertErrors } from '../../../ErrorHandling/ErrorBoundaryFallback';
import { TypeIcons } from '../../../Iconography';
import { ObjectTree } from '../../../v2/components/generic/ObjectTree';
import { NavigationSkeleton } from '../../common/NavigationSkeleton';
import { CustFolderClickWrapper } from '../clickWrappers/helpers';
import { customerCustomerGroupStep } from './CustomerGroups';
export const TreeContextCustomer = ({ contextCustomer, lastKey }) => {
    const navigate = useNavigate();
    const url = contextCustomer !== undefined ? ContainerArbitrator.getCanonicalContainerLinkForObject({ vob: contextCustomer }) : undefined;
    return (_jsx(AlertErrors, { children: contextCustomer !== undefined ? (_jsx(TreeItem2, { itemId: contextCustomer.sk, label: contextCustomer.name, onClick: () => url && navigate(url), slots: { endIcon: TypeIcons.Customer } }, contextCustomer.sk)) : (_jsx(NavigationSkeleton, {}, lastKey + '_Customer')) }, lastKey + '_Customer_errors'));
};
export const TreeCustomersInner = ({ applicationData, contextCustomer, transactionFunctions, lastKey }) => {
    const customerCustomerGroupStepqueryPaths = [customerCustomerGroupStep];
    return (contextCustomer && (_jsx(ObjectTree, { nodeEdgeMapper: applicationData,
        queryPaths: customerCustomerGroupStepqueryPaths,
        contextObjects: [contextCustomer],
        transactionFunctions,
        hideTopStep: false,
        onTypeFolderClickWrapper: CustFolderClickWrapper,
        maintree_rightclick: true }, `${lastKey}_customerCustomerGroupTree`)));
};
export const TreeCustomers = (props) => {
    return (_jsx(TreeItem2, { itemId: props.lastKey + '_Customers', label: 'Customers', children: _jsx(TreeCustomersInner, { ...props }) }, 'AdminCustomers'));
};
